import React, { useState, useEffect, ChangeEvent } from 'react';
import { Row, Col, Alert } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { DetailItem } from '../../../../features/details';
import { updateProduct } from '../../../../services/api/productVmcLink';
import { ApiError, ProductVmcLink } from '../../../../services/openapi';
import { useKeycloak } from '@react-keycloak/web'
import { PropertyInfo } from '../../../../services/openapi/models/PropertyInfo';
import { useNavigate } from "react-router-dom";
import { NotImplementedWarningModal } from '../../../../components/NotImplementedWarningModal';
import { addLinkedItem, deleteAllLinkedItems } from '../../../../services/api/linkedItem';
import { useTranslation } from 'react-i18next'; 

const ProductVmcLinkDetails = () => {
    const [productVmcLink, setProductVmcLink] = useState<any>();
    const [showInputEle, setShowInputEle] = useState<boolean>(false);
    const [showModal, setShowModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState<string[]>([]);
    const [firstTime, setFirstTime] = useState(true);
    const [isRefreshing, setIsRefreshing] = useState<boolean>(false);

    const { keycloak, initialized } = useKeycloak();
    const token = keycloak.token || '';

    const navigate = useNavigate();
    const { t } = useTranslation();

    const navigateBack = () => {
        navigate('/dashboard/details/vmc/vmc-linked-products');
    };

    const setProductVmcLinkData = (data: ProductVmcLink) => {        
        localStorage.setItem('ProductVmcLink', JSON.stringify(data));
   }

    const toggleInputElements = (show: boolean) => {
        setShowInputEle(show);
        if (show) {            
            document.querySelector('.errorMsg')?.classList.add("d-none");
            setErrorMsg([]);
        }
    }

    useEffect(() => {
        if (productVmcLink == null || productVmcLink === undefined) {
            const json = localStorage.getItem('ProductVmcLink') ?? "";
            const item = JSON.parse(json);
            setProductVmcLink(item);

            errorMsg.length = 0;
            document.querySelector('.errorMsg')?.classList.add("d-none");

            if (firstTime && item !== undefined && (item as ProductVmcLink).locationSelection === '') {
                toggleInputElements(true);
                setFirstTime(false);
            }
        }        
    }, [isRefreshing, firstTime, productVmcLink]);


    function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();

        document.querySelector('.errorMsg')?.classList.add("d-none");
        errorMsg.length = 0;

        if (e.currentTarget.checkValidity()) {
            let link: ProductVmcLink = productVmcLink;

            if (typeof link.outputs === 'string') {
                if (link.outputs === '') {
                    link.outputs = [];    
                }
                else {
                    let o : string = link.outputs;
                    link.outputs = o.split(',');
                }
            }

            setProductVmcLinkData(link);
            setIsRefreshing(true);

            updateProduct(token, link.productId, link).then(() => {setIsRefreshing(false);}).catch((error: ApiError) => {  
                try {
                    document.querySelector('.errorMsg')?.classList.remove("d-none");
                    if (error.body) {
                        pushErrorMessages(JSON.parse(error.body)["errors"]);
                        showErrorMessages();
                    }
                    else {
                        showErrorMessages([error.message]);
                    }
                }
                catch (ex) {
                    showErrorMessages(["Error handling response"]);
                }
        });
            toggleInputElements(!showInputEle);
        }
    }

    const pushErrorMessages = (errors: any) => {
        Object.entries<Record<string, any>>(errors).forEach((k: [string, Record<string, any>]) => {
            k[1].forEach((msg: string) => {
                errorMsg.push(msg);
            })
        });
    }

    const showErrorMessages = (errors: string[] | void) => {
        if (errors) {
            errors.forEach((msg: string) => { errorMsg.push(msg); })
        }

        document.querySelector('.errorMsg')?.classList.remove("d-none");
        setIsRefreshing(false);
    }

    return (
        <>
            <div className="">
                <NotImplementedWarningModal
                    showModal={showModal}
                    handleClose={() => {
                        setShowModal(false);
                    }}
                />
            </div>
            <Row className="">
                <Col className="">
                    <Card className="rounded">
                        <Card.Body className="">
                            <form onSubmit={e => handleSubmit(e)}>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>                                
                                <Row className="">
                                    <Col sm="12" className="">
                                        <h4 className="mb-2 qvend-title">{t('automaatdetails')} - {t('productKoppeldetails')}</h4>
                                    </Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" xs="12" className="mt-2">
                                        <div className="table-responsive-lg" style={{ overflowX: 'hidden' }}>
                                            <div>
                                                {productVmcLink && Object.entries<PropertyInfo>(productVmcLink).filter(([key, value]) => productVmcLink["propertyNames"][key] !== undefined).sort((a, b) => productVmcLink["propertyNames"][a[0]].sortOrderLevel - productVmcLink["propertyNames"][b[0]].sortOrderLevel).map(([key, value], index) => (
                                                    <DetailItem key={productVmcLink["propertyNames"][key].sortOrderLevel} propertyName={productVmcLink["propertyNames"][key].name} defaultValue={value} rowColor={index % 2 ? "#cfd5ea" : "#e9ebf5"} editType={productVmcLink["propertyNames"][key].editType} pattern={productVmcLink["propertyNames"][key].valPattern} possibilities={productVmcLink["propertyNames"][key].predefinedValues} hideOnNull={productVmcLink["propertyNames"][key].hideOnNull}
                                                        handleDoubleClick={() => toggleInputElements(true)}
                                                        handleChange={(e: ChangeEvent<HTMLInputElement>) => { productVmcLink[key] = (e.target.value); setProductVmcLink(productVmcLink); }} showInputEle={showInputEle} conditionToShowReferenceValue={productVmcLink[productVmcLink["propertyNames"][key].conditionToShowFieldName]} conditionToShowValue={productVmcLink["propertyNames"][key].conditionToShowValue}></DetailItem>
                                                ))}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="d-none errorMsg">
                                    <Col>
                                        {
                                            errorMsg.map((item, index) => {
                                                return <Alert key={index} variant="warning" className="alert" role="alert">
                                                          <span>{item}</span>
                                                       </Alert>;
                                            })
                                        }                                        
                                    </Col>
                                </Row>
                                <Row style={{ paddingTop: "12px" }}>
                                    <Col>                                        
                                    </Col>
                                    <Col className="text-end">
                                        {productVmcLink !== undefined && (productVmcLink as ProductVmcLink).locationSelection ?
                                            (<button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }} onClick={() => {
                                                document.querySelector('.errorMsg')?.classList.add("d-none");
                                                errorMsg.length = 0;

                                                setProductVmcLinkData(productVmcLink);
                                                deleteAllLinkedItems(token, productVmcLink.vmcId ?? 0, 'Vmc', "Product").then(() => {
                                                if (productVmcLink.productId) {
                                                    addLinkedItem(token, { parentId: productVmcLink.vmcId ?? 0, parentType: 'Vmc', linkedEntityId: productVmcLink.productId, linkedEntityType: "Product" }).then(() => {
                                                        navigate('/dashboard/items-linkers/product-to-vmc');
                                                    }).catch((error: ApiError) => {
                                                        try {
                                                            document.querySelector('.errorMsg')?.classList.remove("d-none");
                                                            pushErrorMessages(JSON.parse(error.body)["errors"]);
                                                            showErrorMessages();
                                                        } catch (ex) {
                                                            showErrorMessages(["Error handling response"]);
                                                        }
                                                    });
                                                }
                                                else {
                                                    navigate('/dashboard/items-linkers/product-to-vmc');
                                                }
                                                }).catch((error: ApiError) => {
                                                    try {
                                                        document.querySelector('.errorMsg')?.classList.remove("d-none");
                                                        pushErrorMessages(JSON.parse(error.body)["errors"]);
                                                        showErrorMessages();
                                                    } catch (ex) {
                                                        showErrorMessages(["Error handling response"]);
                                                    }
                                                });
                                            }}>{t("product.button.product")}</button>) : undefined}
                                    </Col>
                                </Row>                                
                                <Row style={{ paddingTop: "3px" }}>
                                    <Col>
                                        <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px', backgroundColor: "red" }} onClick={() => navigateBack()}>{t("button.back")}</button>                                        
                                    </Col>
                                    <Col className="text-end">
                                        {showInputEle ?
                                            (<button type="submit" className="btn btn-fixed-width" style={{ fontSize: '11px' }}>{t("button.save")}</button>) :
                                            (<button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }} onClick={(e) => { e.preventDefault(); toggleInputElements(true); }}>{t("button.edit")}</button>)
                                        }
                                    </Col>
                                </Row>
                            </form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default ProductVmcLinkDetails;